const SAVE_METADATA = 'saveMetadata'

export function commitMetadata (commit, metadata) {
  commit(SAVE_METADATA, metadata)
}

function saveMetadata (state, metadata) {
  const modules = {}

  for (const key in metadata) {
    const m = metadata[key].group

    if (m != null) {
      if (modules[m] == null) {
        modules[m] = { key: m, members: [] }
      }

      modules[m].members.push(key)
    }
  }

  state.modules = modules
  state.metadata = metadata
}

const mutators = {
  [SAVE_METADATA]: saveMetadata
}

export default mutators
